import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import {
  transparent,
} from '../../utils/ColorUtil';
import Avatar from '../Avatar/Avatar';
import RelativeTime from '../RelativeTime/RelativeTime';
import defaultUserImage from '../../assets/users.png';
import * as color from '../../sass/color.scss';

function NoteMessage({
  className = '',
  style = {},
  // _id = '',
  userId = '',
  username = 'Unknown',
  date = '',
  avatarUrl = '',
  type = '',
  note = '',
  user,
}) {
  // is the message sent by this user?
  const isMyMessage = user._id === userId;
  

  return (
    <div
      className={classNames('NoteMessage', className, { note: type === 'note', activity: type !== 'note' })}
      style={style}
    >
      {type === 'note' ? (
        <div
          style={{
            display: 'flex',
          }}
        >
          <Avatar
            style={{
              alignItems: 'flex-start',
              marginRight: 8,
            }}
            imageUrl={avatarUrl}
            imageDefault={defaultUserImage}
            imageSize={48}
          />

          <div
            style={{
              flexGrow: 1,
            }}
          >
            <div
              style={{
                display: 'flex',
              }}
            >
              <div
                className="username"
                style={{
                  fontSize: 14,
                }}
              >
                {username}
              </div>

              <RelativeTime
                style={{
                  whiteSpace: 'nowrap',
                  marginLeft: 8,
                  fontSize: 12,
                  color: color.manatee,
                }}
                time={date}
              />
            </div>

            <div
              className="message"
              style={{
                display: 'inline-block',
                margin: '8px 0',
                padding: 8,
                backgroundColor: isMyMessage
                  ? transparent(color.primary, 16)
                  : color.lightGray,
                borderRadius: 4,
                lineHeight: '24px',
              }}
            >
              {note}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: color.gray400,
          }}
        >
          <div>
            {note || 'Unknown'}
          </div>

          <div>
            {moment(date).format('lll')}
          </div>
        </div>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(NoteMessage);
